export const COLUMNS_DETALLE_POR_CEREAL_LINEA_5 = [
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'pesoNetoCerealHumedad',
    label: 'Humedad [Tns]',
    options: {
      filter: true,
      sort: true
    }
  },
  {
    name: 'pesoNetoTotal',
    label: 'Total [Tns]',
    options: {
      filter: true,
      sort: true
    }
  }
]

export const COLUMNS_DETALLE_POR_CEREAL_LINEA_5_TO_PRINT = [
  {
    name: 'cereal',
    label: 'Cereal',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    width: 50,
    mantenerCase: true
  },
  {
    name: 'pesoNetoCerealHumedad',
    label: 'Humedad [Tns]',
    width: 70,
    mantenerCase: true
  },
  {
    name: 'pesoNetoTotal',
    label: 'Total [Tns]',
    width: 60,
    mantenerCase: true
  }
]
